import styled from "styled-components";
import ListWithPagination from "../ListsWithPagination";
import { TableWithPagination } from "../TableWithPagination";

interface Props {
  data: {
    id: number;
    count: number;
    generated_by: string;
    date_time: string;
    status: string;
  }[];

  currentPage: number;
  totalData: number;
  rowsPerPage: number;
  isTableDataLoading: boolean;
  onPageChange: (page: number) => void;
}

const PCTable = ({
  data,
  isTableDataLoading,
  totalData,
  currentPage,
  rowsPerPage,
  onPageChange,
}: Props) => {
  const columns = [
    {
      path: "id",
      label: "ID",
    },
    {
      path: "date_time",
      label: "Date & Time",
    },
  ];

  return (
    <>
      <TableWrapper>
        <TableWithPagination
          onPageChange={onPageChange}
          totalData={totalData}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
        />
      </TableWrapper>
      <ListWrapper>
        <ListWithPagination
          onPageChange={onPageChange}
          totalData={totalData}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          title={"Physical Card details"}
        />
      </ListWrapper>
    </>
  );
};
const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 768px) {
    padding-top: 4.5rem;
    display: none;
  }
`;
const ListWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

export default PCTable;
